module.exports = __webpack_public_path__ + "assets/img/0406.c73dd652.png";